import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { CaseUploadService } from 'src/app/case-upload.service';
import { PersonalDetailsDataService } from 'src/app/personal-details-data.service';
import { PersonalDetailsService } from 'src/app/personal-details.service';
import { SaveConfirmationComponent } from 'src/app/save-confirmation/save-confirmation.component';

@Component({
  selector: 'app-personal-data-entry',
  templateUrl: './personal-data-entry.component.html',
  styleUrls: ['./personal-data-entry.component.scss']
})
export class PersonalDataEntryComponent implements OnInit {
  @Output() dataEvent = new EventEmitter<boolean>();
  @Output() dataRemarks = new EventEmitter<boolean>();
  personalDetails: any
  caseId: any
  case_id: any

  navItems: any[] = []
  personalDetailsDataEntryForm = new FormGroup({
    status: new FormControl('')
  })
  personalDetailsFields: any = []
  inputqcComments: string
  statusInDb: string
  constructor(
    private personalDetailsDataService: PersonalDetailsDataService,
    private caseUploadService: CaseUploadService,
    private activatedRoute: ActivatedRoute,
    private personalDetailsService: PersonalDetailsService,
    private snackBar: MatSnackBar,
    private dialog:MatDialog
  ) { }

  ngOnInit(): void {
    this.getComponentDetails()
    this.getPersonalDetails()
  }

  


  // Added By Navin On 15/2/23
  getPersonalDetails() {
    this.personalDetailsService.findForCde(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
      response => {
        this.personalDetailsFields = response[0].personalDetailsFields;
        const dateDefault = (date) => {
          if (date) {
            let dateValue = new Date(date);
            let dd = dateValue.getDate();
            let mm = dateValue.getMonth() + 1;
            let yyyy = dateValue.getFullYear().toString();
  
            
            let stringdd = dd < 10 ? '0' + dd : dd.toString();
            let stringmm = mm < 10 ? '0' + mm : mm.toString();
  
            return `${yyyy}-${stringmm}-${stringdd}`;
          } else {
            return ''; 
          }
        };
  
        this.personalDetailsFields[3].value = dateDefault(this.personalDetailsFields[3].value);
        this.personalDetailsFields[7].value = dateDefault(this.personalDetailsFields[7].value);
        this.addFormControlsForPersonalDetails();
      },
      error => {
        this.showError("Error Configuring Personal Details");
      }
    );
  }

  async getComponentDetails() {
    await this.getCaseDetails()
    this.readPersonalDetails()
  }

  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          // console.log("Got reponse from cde case details")
          this.caseId = response.caseId
          this.case_id = response._id
          resolve(true)
        },
        error => {
          this.showError("Error reading Case Details")
          resolve(false)
        })
    })
    return promise
  }

  
  readPersonalDetails() {
    this.personalDetailsDataService.readForCde(this.case_id, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
      response => {
        if (response) {
          this.dataEvent.emit(!!response)
          this.personalDetails = response._id;
          this.personalDetailsFields.forEach(item => {
            if (item.type != 'DATE') {
              this.personalDetailsDataEntryForm.get(item.name).setValue(response[item.name]);
            } else {
              let dateValue = new Date(response[item.name]);
              let dd = dateValue.getDate();
              let mm = dateValue.getMonth() + 1;
              let yyyy = dateValue.getFullYear().toString();
              let stringdd = '';
              let stringmm = ''

              if (dd < 10) {
                stringdd = '0' + dd;
              } else {
                stringdd = dd.toString();
              }
              if (mm < 10) {
                stringmm = '0' + mm;
              } else {
                stringmm = mm.toString();
              }
              this.personalDetailsDataEntryForm.get(item.name).setValue(yyyy + '-' + stringmm + '-' + stringdd);
            }
          })
          if (response.status == 'CDE-REJECTED') {
            this.inputqcComments = response.inputqcComments
            this.statusInDb = response.status
            this.dataRemarks.emit(true)
          }
        } else {
          this.dataEvent.emit(!!response)
        }

      },
      error => {
        this.showError(error.error.message);
      }
    )
  }

  addFormControlsForPersonalDetails() { 
    this.personalDetailsFields.forEach(item => {
      this.personalDetailsDataEntryForm.addControl(item.name, new FormControl(''));
      if (item.mandatory) {
        this.personalDetailsDataEntryForm.get(item.name).setValidators(Validators.required);
      }
    })

  }
  getFieldSize(personalDetailsField) {
    return personalDetailsField.size;
  }

  saveConfirmation(){
    const confirmDialog = this.dialog.open(SaveConfirmationComponent,{
      width:'400px',data:{message:`Are you sure that you want to submit this form `}
    });
    confirmDialog.afterClosed().subscribe(result=>{
      if(result.event=='confirmed'){
        this.saveButtonClicked();
      }
    })  
  }

  saveButtonClicked() {
    let personalDetailsData = this.personalDetailsDataEntryForm.getRawValue()
    personalDetailsData.status = "CDE-COMPLETED"
    personalDetailsData.case = this.case_id
    if (this.personalDetails == null) {
      this.personalDetailsDataService.createForCde(personalDetailsData, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          this.personalDetails = response._id
          this.dataEvent.emit(true)
          this.showMessage("Personal Details Saved");
        },
        error => {
          console.log('error == ', error);
          
          this.showError(error.error.message);
        })
    } else {
      this.personalDetailsDataService.updateForCde(this.personalDetails, personalDetailsData, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          this.personalDetails = response._id
          this.dataEvent.emit(true)
          this.showMessage("Personal Details Saved");
        },
        error => {
          console.log('error == ', error);
          
          this.showError("Error Updating Personal Details");
        })
    }

  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' });
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Info', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' });
  }

}
